import { getProductBadgeIcon } from "@wojo/storyblok/src/client/get-product-badge-icon";
import { StatusLabel } from "@wojo/ui";

type DepartureDateAvailabilityBadgeProps = {
    departureStatusBadge: {
        text: string;
        variant: "neutral" | "info" | "urgent";
        icon?: string;
    };
};

export const DepartureDateAvailabilityBadge: React.FC<
    DepartureDateAvailabilityBadgeProps
> = ({ departureStatusBadge }) => {
    return (
        <StatusLabel
            variant="primary"
            icon={getProductBadgeIcon(departureStatusBadge.icon)}
            status={departureStatusBadge.variant}
            size="small"
            text={departureStatusBadge.text}
        />
    );
};
